import type { FaireCollectionEntity } from "../../entity_types/collection";

export const pbc_thzpmfgutd: FaireCollectionEntity = {
  token: "pbc_thzpmfgutd",
  type: "collection",
  name: "Seaside Whimsy – A Nautical Organic Babywear Collection",
  heroImageUrl:
    "https://cdn.faire.com/fastly/357e8fc61f81c192ceef9e2f8cd00c36106670a6a5d84cca89924add003f7d0a.jpeg",
  itemCount: 64,
  description:
    'Splash into summer style with "Seaside Whimsy," a charming coastal collection that brings the magic of the ocean to your baby’s wardrobe. It is conscientiously designed in the USA and ethically made by artisans at a GOTS-certified facility in India.',
  brandToken: "b_7fghelgl",
  productTokens: [],
  meta: {
    source: "api",
    importedAt: "2026-08-11T04:59:20.347Z",
    importedBy: "entity-db-import-collections",
  },
};
